/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ListDestinationsParams = zod.object({
	type: zod.enum(['webhook', 'callback'])
});

export type ListDestinationsParams = zod.input<typeof ListDestinationsParams>;
export type ListDestinationsParamsOutput = zod.output<typeof ListDestinationsParams>;
